import React, { Component } from 'react';

import { WithStyles, withStyles } from '@mui/styles';
import { withTranslate } from '../../../core/TenantProvider';
import APPasswordResetStyles from './styles/APPasswordReset.style';
import classnames from 'classnames';
import _ from 'lodash';
import APHeading from '../../atoms/APHeading';
import APInput from '../../atoms/APInput';
import APButton from '../../atoms/APButton';
import APPasswordCriteria from '../../atoms/APPasswordCriteria/APPasswordCriteria';
import { InitialSettingValues } from '../../../containers/SettingsContainer/SettingsContainer';

interface APPasswordResetProps extends WithStyles<typeof APPasswordResetStyles> {
    translate: Function,
    values: InitialSettingValues | undefined,
    handleChange: Function,
    handleBlur: Function,
    formRef: React.RefObject<any>,
    touched: any,
    errors: InitialSettingValues,
    editPassword: boolean,
    onEditPassword: Function
}

interface APPasswordResetState {
    editPassword: boolean
}

class APPasswordReset extends Component<APPasswordResetProps, APPasswordResetState> {

    constructor(props: any) {
        super(props);
        this.state = {
            editPassword: false
        }

        this.onEditPassword = this.onEditPassword.bind(this);
    }

    componentDidMount(): void {
        this.setState({
            editPassword: this.props.editPassword
        });
    }

    componentDidUpdate(prevProps: Readonly<APPasswordResetProps>): void {
        !(_.isEqual(prevProps.editPassword, this.props.editPassword)) &&
            this.setState({
                editPassword: this.props.editPassword
            });
    }

    onEditPassword() {
        this.setState({
            editPassword: true,
        }, () => {
            const formik = this.props.formRef.current;
            formik.setValues(curValues => ({
                ...curValues,
                currentPassword: '',
                isEditPassword: true
            }))
            if (this.props.onEditPassword) {
                this.props.onEditPassword(true)
            }
        });
    }

    render() {
        const {
            classes,
            translate,
            values,
            handleChange,
            handleBlur,
            touched,
            errors
        } = this.props;

        const {
            editPassword
        } = this.state;

        const currentPasswordInput = classnames(classes.formSectionInput, {
            [classes.currentPasswordInput]: !editPassword
        });

        const confirmPasswordInput = classnames(classes.formSectionInput, {
            [classes.currentPasswordInput]: editPassword
        });

        return (
            <>
                <div className={classes.formSectionHeader}>
                    <APHeading className={classes.formSectionHeading}
                        variant="body1">
                        {translate('settings.password.label.heading')}
                    </APHeading>
                </div>
                <div className={classes.formSectionContent}>
                    <APInput
                        name="currentPassword"
                        value={values?.currentPassword}
                        className={currentPasswordInput}
                        autoComplete="off"
                        label={translate('settings.password.label')}
                        type="password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched?.currentPassword && Boolean(errors.currentPassword)}
                        helperText={touched?.currentPassword && errors.currentPassword}
                        disabled={!editPassword}
                        supportsUnmasking={false}
                        isCoralogixMasked={true}
                    />
                    {!editPassword &&
                        <APButton
                            className={classes.changePasswordLink}
                            onClick={this.onEditPassword}
                            variant="text"
                            data-testid='edit-password-button'
                            color="primary">
                            {translate('settings.password.editpassword.label')}
                        </APButton>
                    }
                    {editPassword && (
                        <>
                            <APInput
                                name="newPassword"
                                value={values?.newPassword}
                                className={classes.formSectionInput}
                                autoComplete="off"
                                label={translate('settings.password.newpassword.label')}
                                type="password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched?.newPassword && Boolean(errors?.newPassword)}
                                helperText={touched?.newPassword && errors.newPassword}
                                supportsUnmasking={false}
                                isCoralogixMasked={true}
                            />
                            <APInput
                                name="confirmPassword"
                                value={values?.confirmPassword}
                                className={confirmPasswordInput}
                                autoComplete="off"
                                label={translate('settings.password.confirmpassword.label')}
                                type="password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched?.confirmPassword && Boolean(errors?.confirmPassword)}
                                helperText={touched?.confirmPassword && errors.confirmPassword}
                                supportsUnmasking={false}
                                isCoralogixMasked={true}
                            />
                            <APPasswordCriteria inputValue={values?.newPassword} />
                        </>
                    )}
                </div>
            </>
        )
    }
}

export default withTranslate(
    withStyles(APPasswordResetStyles)(APPasswordReset)
);